import { isAdminRole } from './role';
import { baseNavItems } from './navConfig';

/**
 * Server-side utility for navigation redirection based on user permissions and role
 * This is the middleware-compatible version of useNavigationRedirect hook
 */
export function getNavigationRedirectPath(
  userRole: string,
  userPermissions: string[] = [],
): string {
  console.log('🔍 [Navigation Redirect] User info:', {
    role: userRole,
    permissions: userPermissions,
  });

  // Admin users always go to admin dashboard
  if (isAdminRole(userRole)) {
    console.log('✅ [Navigation Redirect] Admin user -> /admin/dashboard');
    return '/admin/dashboard';
  }

  console.log(
    '👤 [Navigation Redirect] Non-admin user, checking accessible routes...',
  );

  // Find first accessible route for non-admin users based on permissions
  // Filter out admin-only items and use array order as priority
  for (const item of baseNavItems) {
    // Skip admin-only items for non-admin users
    if (item.adminOnly && !isAdminRole(userRole)) {
      console.log(
        `⏭️ [Navigation Redirect] Skipping admin-only: ${item.baseRoute}`,
      );
      continue;
    }

    // Check if user has any of the required permissions for this route
    const hasAccess =
      item.requiredPermissions.length === 0 ||
      item.requiredPermissions.some((permission) =>
        userPermissions.includes(permission),
      );

    console.log(
      `🔍 [Navigation Redirect] ${item.baseRoute}: permissions=${JSON.stringify(item.requiredPermissions)}, hasAccess=${hasAccess}`,
    );

    if (hasAccess) {
      const selectedRoute = `/${item.baseRoute}`;
      console.log(`✅ [Navigation Redirect] Selected: ${selectedRoute}`);
      return selectedRoute;
    }
  }

  // Universal fallback for all users
  console.log(
    '🔄 [Navigation Redirect] No accessible routes, using fallback: /profile',
  );
  return '/profile';
}
